/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input } from '@angular/core';
import { ListsService } from '../../../../core/lists/lists.service'
// import { ListsService } from '../../../../core/lists/lists.service';
import { environment } from '../../../../environments/environment';
import { ConfigService } from 'src/core/service/config.service';
import { skip } from 'rxjs/operators';
// import { ConfigService } from '../../../core/service/config.service';

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.scss']
})
export class BannersComponent implements OnInit {
  @Input() banners: Array<any> = [];
  public imageUrl: any;
  public BrandList: any = [];
  full_category: any[] = [];
  skipdata :any = []
  get_skip_data :any = [];
  insert_data:any[] = [{name:'Why Buy From East West ?',
category:{name :['In Business for 40 Years', 'Lifetime Guarantee', 'Relocation Consultation', 'Steam Press', 'Garment Steamer', 'Ironing Board', 'Ironing Station']}}
]


 appliancesList:any[] = [
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Multisystem%20Electronics%20updated/DVD%20Players/JVC%20XV-Y225/&name=JVC%20XV-Y225%20DVD%20-1.jpg  ',
    title:'Audio/Video',
    appliances: [
      'Television (TV)',
      'Home Theater System',
      'Blu-ray/DVD Player',
      'Gaming Console',
      'Audio Receiver',
      'Projector',
      'Soundbar'
    ]
  },
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/220%20Volt%20Appliances%20(Overseas%20use%20only)/Refrigerators/Refrigerators%20AEG/AEG%20RDB72721AW/&name=RDB72721AW_1.jpg',
    title:'220V major Appliances',
    appliances: [
      'Electric Range',
      'Refrigerator',
      'Clothes Dryer',
      'Washing Machine',
      'Dishwasher',
      'Microwave Oven',
      'Water Heater'
    ]
  },
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Countertop%20Appliances/Stand%20Mixer/Z-Kenwood%20KEAT320B/KEAT320B/&name=AT320B-1.jpg',
    title:'220V Kitchen Appliances',
    appliances: [
      'Electric Oven',
      'Induction Cooktop',
      'Coffee Machine',
      'Mixer/Blender',
      'Dishwasher',
      'Deep Fryer',
      'Refrigerator'
    ],
  },
  {
    
    title:'Why Buy From East West ?',
    appliances: ['In Business for 40 Years', 'Lifetime Guarantee', 'Relocation Consultation', 'Steam Press', 'Garment Steamer', 'Ironing Board', 'Ironing Station'],
  },
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Multisystem%20Electronics%20updated/TVS%20LED%20LCD%20and%20Plasma%20And%20Multisystem/Sony%20KD-49X7000/&name=KD-49X7000-1.jpg',
    title:'Multisystem TV',
    appliances: [
      'Home Theater',
      'Audio/Video Receiver',
      'Blu-ray/DVD Player',
      'Gaming Console',
      'Projector',
      'Soundbar System',
      'Multimedia PC'
    ],
  },
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Office%20Products%20updated/Printers%20Scanners%20and%20Multifunction%20Machines/Okidata%20OKMFP480/&name=Okidata%20OKMFP480_1.jpg',
    title:'Office Appliances',
    appliances: [
      'Desktop Computer',
      'Laser Printer',
      'Fax Machine',
      'Photocopier',
      'Scanner',
      'Shredder',
      'UPS'
    ],
  },
  {
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/220%20Volt%20Appliances%20(Overseas%20use%20only)/Air%20Conditioners/Air%20Conditioner%20Frigidaire%20by%20Electrolux/Frigidaire%20by%20Electrolux%20FS12K57CCH/&name=FS12K57CCH_1.jpg&width=150&height=150',
    title:'Air Conditioners',
    appliances: [
      'Window Air Conditioner',
      'Split Air Conditioner',
      'Central Air Conditioner',
      'Ductless Mini-Split',
      'Portable',
      'Wall-Mounted',
      'Ceiling Cassette '
    ],
  },
  {  
    image: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/220%20Volt%20Appliances%20(Overseas%20use%20only)/Air%20Conditioners/Air%20Conditioners%20EWI/EWI%20AKACL188C/&name=Air-Conditioners_1.jpg',
    title:'Other 220 Volt Products',
    appliances: [
      'Espresso Machine',
      'Water Pump',
      'Sewing Machine',
      'Welding Machine',
      'Stabilizer',
      'Printer',
      'Ice Maker'
    ],
  },

];


  storename = '';
  FeatureList = [];
  imagePath: string;
  constructor(
    private listService: ListsService,
    private configService: ConfigService,
    
  ) { }

  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    this.storename = environment.storename;
    this.FeatureProduct(this.storename);
    this.getcategory()
    this.imagePath = this.configService.getImageUrl();
  }

  public getBgImage(index) {
    const bgImage = {
      'background-image':
        index != null
          ? 'url(" + this.banners[index].image + ")'
          : 'url(https://via.placeholder.com/600x400/ff0000/fff/)'
    };
    return bgImage;
  }


  // Body Section
  FeatureProduct(id: any) {
    const params = {
      keyword: id,
      limit: ''
    };
    this.listService.getFeaturedListList(params).subscribe((res: any) => {
      const List = res.data.reverse();
      for (let i = 0; i < List.length; i++) {
        if (List[i].position !== null && List[i].position !== 0 && List[i].pricerefer !== '') {
          const items = List[i];
          items.prefer = items.pricerefer;
          items.pricerefer = items.pricerefer.split('.');
          items.priceonly = items.price.split('.');
          this.FeatureList.push(items);
        }
      }
      this.FeatureList = this.FeatureList.sort((a, b) =>
        a.position - b.position
      );
      console.log('FeatureList-->', this.FeatureList);

    });
  }

getcategory(){
  const params: any = {};
params.limit = '';
params.offset = 0;
params.keyword = '';
params.sortOrder = '';

  // this.listSandBox.getCategoryList(params);
  this.listService.getCategoryList(params).subscribe((res1: any) => {




var  appliancesList1:any= 
   
  {
    image:"",
    imagePath:"",
    name:'Why Buy From East West ?',
    categorySlug:'blogs',
    children: [
      {
        image:"",
        imagePath:"",
        name:'In Business for 40 Years',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Lifetime Guarantee',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Relocation Consultation',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Steam Press',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Garment Steamer',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Ironing Board',
        categorySlug:'',
        children: [],
      },
      {
        image:"",
        imagePath:"",
        name:'Ironing Station',
        categorySlug:'',
        children: [],
      }
     ]
  };
    res1.data.forEach((item,index) => {
      if(index==4 ){
        this.full_category.push(appliancesList1)
      }
      if(index!=8 && item.categorySlug!="special-deals"){
      this.full_category.push(item)
      }
    });
     console.log("test", this.full_category);
     for(let item of this.full_category){
      if(item.categorySlug !== 'special-deals'){
        this.get_skip_data.push(item)
      }
     }
     console.log("test",this.get_skip_data)

      // this.full_category = res1.data;
      // this.full_category.push()
      // this.skipdata = []
      // console.log("valuessss",this.full_category)
      // let index = 0;
      
      // this.full_category.push(this.insert_data)
    
  })

}





}
